import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./compound_mod_group_slot_type.js";
//#region src/compound_mod_group_slot_type_helper.ts
var compound_mod_group_slot_type_helper_exports = /* @__PURE__ */ __exportAll({ name: () => name });
function name(type) {
	switch (type) {
		case "empty": return "Empty Slot";
		case "placeholder": return "Placeholder Slot";
		case "real": return "Pick a Real Mod";
	}
}
//#endregion
export { compound_mod_group_slot_type_helper_exports, name };

//# sourceMappingURL=compound_mod_group_slot_type_helper.js.map